<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <form>
    <div class="card" *ngIf="datosUsuarioEdit?.tipoUsuario?.nombreTipo != 'DANE'">
      <div class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;" *ngIf="datosUsuarioEdit?.tipoUsuario?.nombreTipo == 'CHV'">Usuario reportante CHV</h4>
        <h4 style="color: white;" *ngIf="datosUsuarioEdit?.tipoUsuario?.nombreTipo == 'FIVI'">Usuario reportante FIVI</h4>
      </div>
      <div class="card-body">
        <div class="container justify-content">
          <table>
            <tr>
              <td class="col-1"><label>Usuario:</label></td>
              <td class="col-auto"><input class="form-control col-3" name="nitfuente" [(ngModel)]="datosUsuarioEdit.username" disabled></td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td class="col-1"><label>Razón social:</label></td>
              <td class="col-7"><input class="form-control" name="RazonSocial" [(ngModel)]="fuenteUsuario.nombEntidad" disabled></td>
              <td class="col-1"><label>NIT:</label></td>
              <td class="col-2"><input class="form-control" name="nit" [(ngModel)]="fuenteUsuario.nit" disabled></td>
            </tr>
          </table>
            <br>
          <table>
            <tr>
              <td class="col-1"><label>Dirección:</label></td>
              <td class="col-4"><input class="form-control" name="direccion" [(ngModel)]="fuenteUsuario.direccion" disabled></td>
              <td class="col-1"><label>Nombre comercial:</label></td>
              <td class="col-5"><input class="form-control" name="comercial" [(ngModel)]="fuenteUsuario.nombEntidad" disabled></td>
            </tr>
          </table>
            <br>
          <table>
            <tr>
              <td class="col-1"><label>Departamento:</label></td>
              <td class="col-auto"><input class="form-control" name="depto" [(ngModel)]="AuxDeptoMuni.departamento" disabled></td>
              <td class="col-1"><label>Municipio:</label></td>
              <td class="col-auto"><input class="form-control" name="muni" [(ngModel)]="AuxDeptoMuni.nommpio" disabled></td>
              <td class="col-1"><label>Teléfono:</label></td>
              <td class="col-auto"><input class="form-control" name="telefono" [(ngModel)]="fuenteUsuario.telefono" disabled></td>
            </tr>
          </table>
            <br>
            <div><b>Responsable del usuario y clave</b></div>
            <br>
          <table>
            <tr>
              <td class="col-auto"><label>Tipo documento:</label></td>
              <td class="col-3"><select class="form-select" name="tipoidentifiacion" [(ngModel)]="datosUsuarioEdit.tipoIdent">
                <option value="" selected></option>
                <option value="CC">Cédula de ciudadanía</option>
                <option value="CE">Cédula de extranjería</option>
              </select></td>
              <td class="col-auto"><label>Número de identificación:</label></td>
              <td class="col-2"><input type="text" class="form-control" name="numidentificacion" [(ngModel)]="datosUsuarioEdit.identificacion" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></td>
              <td class="col-auto"><label>Nombres:</label></td>
              <td class="col-4"><input type="text" class="form-control" name="nombres" [(ngModel)]="datosUsuarioEdit.nombres" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"></td>
            </tr>
          </table>
            <br>
          <table>
            <tr>
              <td class="col-auto"><label>Correo:</label></td>
              <td class="col-6"><input type="text" class="form-control" name="email1" [formControl]="email1"></td>
              <td class="col-auto"><label>Confirmar correo:</label></td>
              <td class="col-6"><input type="text" class="form-control" name="email2" [formControl]="email2"></td>
            </tr>
          </table>
            <br>
          <table>
            <tr>
              <td class="col-1"><label>Teléfono:</label></td>
              <td class="col-auto"><input type="text" class="form-control" name="tel" [(ngModel)]="datosUsuarioEdit.telefono" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></td>
              <td class="col-1"><label>Extensión:</label></td>
              <td class="col-2"><input type="text" class="form-control" name="ext" [(ngModel)]="datosUsuarioEdit.extencion" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></td>
              <td class="col-1"><label>Cargo:</label></td>
              <td class="col-3"><input type="text" class="form-control" name="cargo" [(ngModel)]="datosUsuarioEdit.cargo"  oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-secondary" (click)="regresar()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardar()" [disabled]="btnguardar">Guardar</button>
      </div>
    </div>

    <!--Editar usuarios DANE-->
    <div class="card" *ngIf="datosUsuarioEdit?.tipoUsuario?.nombreTipo == 'DANE'">
      <div class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;" >Usuario DANE {{datosUsuarioEdit?.tipoUsuario?.usTipoTipo}}</h4>
      </div>
      <div class="card-body">

        <div class="container">
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Perfil:</a>
              </div>
              <div class="row">
                <select class="form-select" name="rol" [(ngModel)]="tipoUsuarioDane" (change)="cambiarTipoUsuarioDane($event.target.value)">
                  <option value="1">Administrador</option>
                  <option value="2">Tematico</option>
                  <option value="3">Operativo</option>
                </select>
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Usuario:</a>
              </div>
              <div class="row">
                <input class="form-control" name="username" [(ngModel)]="datosUsuarioEdit.username" disabled>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Tipo documento:</a>
              </div>
              <div class="row">
                <select class="form-select" name="tipoidentifiacion" [(ngModel)]="datosUsuarioEdit.tipoIdent">
                  <option value="CC">Cédula de ciudadanía</option>
                  <option value="CE">Cédula de extranjería</option>
                </select>
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Número documento:</a>
              </div>
              <div class="row">
                <input class="form-control" name="numdocumento" [(ngModel)]="datosUsuarioEdit.identificacion" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Nombres:</a>
              </div>
              <div class="row">
                <input class="form-control" name="nombres" [(ngModel)]="datosUsuarioEdit.nombres" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Apellidos:</a>
              </div>
              <div class="row">
                <input class="form-control" name="apellidos" [(ngModel)]="datosUsuarioEdit.apellidos" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Correo:</a>
              </div>
              <div class="row">
                <input type="text" class="form-control" name="email1" [formControl]="email1">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Confirmar correo:</a>
              </div>
              <div class="row">
                <input type="text" class="form-control" name="email2" [formControl]="email2">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Télefono:</a>
              </div>
              <div class="row">
                <input class="form-control" name="telefono" [(ngModel)]="datosUsuarioEdit.telefono" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Extensión:</a>
              </div>
              <div class="row">
                <input class="form-control" name="extencion" [(ngModel)]="datosUsuarioEdit.extencion" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </div>
            </div>
            <div class="col" style="margin: 1%;">
              <div class="row">
                <a>Cargo:</a>
              </div>
              <div class="row">
                <input class="form-control" name="cargo" [(ngModel)]="datosUsuarioEdit.cargo" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-secondary" (click)="regresar()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardarUsuarioDane()" [disabled]="btnguardar">Guardar</button>
      </div>
    </div>
  </form>
</body>


